import { render, staticRenderFns } from "./GeneralCommentView.vue?vue&type=template&id=4da98f42&scoped=true&"
import script from "./GeneralCommentView.vue?vue&type=script&lang=ts&"
export * from "./GeneralCommentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da98f42",
  null
  
)

export default component.exports